import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { platformDetectionSelector } from 'redux-store/platformDetection/platformDetection.selector'

interface ConditionalRenderProps {
  mobileApp?: boolean
  web?: boolean
  children: React.ReactNode
}

export const ConditionalRender: FC<ConditionalRenderProps> = ({
  mobileApp = true,
  web = true,
  children
}) => {
  const isMobileApp = useSelector(platformDetectionSelector)

  if (isMobileApp) {
    return mobileApp ? <>{children}</> : null
  } else {
    return web ? <>{children}</> : null
  }
}
